module.exports = __webpack_public_path__ + "static/img/album5_202501_01.857aac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album5_202501_01.jpg
// module id = /h5o
// module chunks = 100